import { ValidatorForm } from "react-material-ui-form-validator";

class Validators {
  isMatchValue = (value) => {
    this.mount(value);
  };

  mount = (isMatchValue) => {
    ValidatorForm.addValidationRule("isValidPassword", (value) => {
      var strongRegex = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64}$)"
      );
      if (!strongRegex.test(value)) {
        return false;
      }
      return true;
    });

    ValidatorForm.addValidationRule("isMatch", (value) => {
      if (isMatchValue.password !== value) {
        return false;
      }
      return true;
    });
  };

  unmount = () => {
    ValidatorForm.removeValidationRule("isValidPassword");
    ValidatorForm.removeValidationRule("isMatch");
  };
}

export default Validators;
